import React from "react";
import { Box, Typography, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StatusFilter from "../../components/StatusFilter";
import CommonPagination from "../../components/Table/CommonPagination";
import { limitChar } from "../../utils/common";

const CategoryTable = ({ classes, setPostFilter, handleSearchChange, filteredCategories, anchorElFilter, handleClickFilter, handleCloseFilter, anchorEl, selectedCategoryIndex, handleClick, handleClose, handleEditCategory, handleOpenDeleteDialog, handleViewCategory, isAdmin, rowsPerPage, totalCategories, page, handlePageChange }) => (
      <Box>
        <Box
          sx={{
            padding: "15px 15px 0 15px",
            borderRadius: "6px",
            boxShadow:
              "rgba(0, 0, 0, 0.05) 0 6px 24px 0, rgba(0, 0, 0, 0.08) 0 0 0 1px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "15px",
              flexDirection: {
                xs: "column",
                sm: "row",
                md: "row",
                lg: "row",
                xl: "row",
              },
            }}
          >
            <Box
              sx={{
                marginRight: "15px",
                display: "flex",
                alignItems: "center",
                width: {
                  xs: "100%",
                  sm: "auto",
                  md: "auto",
                  lg: "auto",
                  xl: "auto",
                },
                marginBottom: {
                  xs: "10px",
                  sm: 0,
                  md: 0,
                  lg: 0,
                  xl: 0,
                },
                justifyContent: {
                  xs: "space-between",
                  sm: "flex-start",
                  md: "flex-start",
                  lg: "flex-start",
                  xl: "flex-start",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: {
                    xs: "12px",
                    sm: "14px",
                    md: "15px",
                    lg: "15px",
                    xl: "16px",
                  },
                  paddingRight: "10px",
                }}
              >
                Type Filter:
              </Typography>
              <StatusFilter setPostFilter={setPostFilter} />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: {
                  xs: "100%",
                  sm: "auto",
                  md: "auto",
                  lg: "auto",
                  xl: "auto",
                },
              }}
            >
              <input
                placeholder="Search"
                type="text"
                onChange={handleSearchChange}
                className="search-field-ui"
              />
            </Box>
          </Box>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow className={classes.stickyHeader}>
                  <TableCell
                    sx={{
                      fontSize: {
                        xs: "14px",
                        sm: "15px",
                        md: "15px",
                        lg: "16px",
                        xl: "16px",
                      },
                      color: "#000",
                      fontWeight: 600,
                      padding: {
                        xs: "10px 5px",
                        sm: "15px 10px",
                        md: "15px 10px",
                        lg: "20px 15px",
                        xl: "20px 15px",
                      },
                      backgroundColor: "#e0e0e0",
                    }}
                  >
                    Logo
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: {
                        xs: "14px",
                        sm: "15px",
                        md: "15px",
                        lg: "16px",
                        xl: "16px",
                      },
                      color: "#000",
                      fontWeight: 600,
                      padding: {
                        xs: "10px 5px",
                        sm: "15px 10px",
                        md: "15px 10px",
                        lg: "20px 15px",
                        xl: "20px 15px",
                      },
                      backgroundColor: "#e0e0e0",
                    }}
                  >
                    Category Name
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: {
                        xs: "14px",
                        sm: "15px",
                        md: "15px",
                        lg: "16px",
                        xl: "16px",
                      },
                      color: "#000",
                      fontWeight: 600,
                      padding: {
                        xs: "10px 5px",
                        sm: "15px 10px",
                        md: "15px 10px",
                        lg: "20px 15px",
                        xl: "20px 15px",
                      },
                      backgroundColor: "#e0e0e0",
                    }}
                  >
                    Hashtags
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: {
                        xs: "14px",
                        sm: "15px",
                        md: "15px",
                        lg: "16px",
                        xl: "16px",
                      },
                      color: "#000",
                      fontWeight: 600,
                      padding: {
                        xs: "10px 5px",
                        sm: "15px 10px",
                        md: "15px 10px",
                        lg: "20px 15px",
                        xl: "20px 15px",
                      },
                      backgroundColor: "#e0e0e0",
                    }}
                  >
                    <Box>
                      Type
                      <IconButton
                        sx={{
                          padding: 0,
                          marginLeft: "10px",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#142C5C",
                          },
                        }}
                        onClick={(event) => handleClickFilter(event)}
                      >
                        {/* <FilterListIcon/> */}
                      </IconButton>
                      <Menu
                        anchorEl={anchorElFilter}
                        open={Boolean(anchorElFilter)}
                        onClose={handleCloseFilter}
                        sx={{
                          "& .MuiPaper-elevation": {
                            borderRadius: "4px",
                            "& .MuiList-padding": {
                              padding: 0,
                            },
                          },
                        }}
                      >
                        <MenuItem
                          sx={{
                            padding: "5px 15px !important",
                            borderBottom: "1px solid #e0e0e0",
                            "&:hover": {
                              backgroundColor: "#e0e0e0 !important",
                              color: "#000",
                            },
                          }}
                          onClick={() => {
                            handleCloseFilter();
                          }}
                        >
                          Post
                        </MenuItem>
                        <MenuItem
                          sx={{
                            padding: "5px 15px !important",
                            borderBottom: "1px solid #e0e0e0",
                            "&:hover": {
                              backgroundColor: "#e0e0e0 !important",
                              color: "#000",
                            },
                          }}
                          onClick={() => {
                            handleCloseFilter();
                          }}
                        >
                          Live
                        </MenuItem>
                      </Menu>
                    </Box>
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: {
                        xs: "14px",
                        sm: "15px",
                        md: "15px",
                        lg: "16px",
                        xl: "16px",
                      },
                      color: "#000",
                      fontWeight: 600,
                      padding: {
                        xs: "10px 5px",
                        sm: "15px 10px",
                        md: "15px 10px",
                        lg: "20px 15px",
                        xl: "20px 15px",
                      },
                      backgroundColor: "#e0e0e0",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredCategories.length === 0 ? (
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      sx={{
                        textAlign: "center",
                        height: "calc(100vh - 280px)",
                        fontSize: {
                          xs: "12px",
                          sm: "13px",
                          md: "14px",
                          lg: "15px",
                          xl: "15px",
                        },
                        color: "#333",
                        padding: {
                          xs: "10px 5px",
                          sm: "10px",
                          md: "10px",
                          lg: "10px 15px",
                          xl: "10px 15px",
                        },
                      }}
                    >
                      No categories found
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredCategories.map((category, index) => (
                    <TableRow key={category._id}>
                      <TableCell
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        <img
                          src={category.logo}
                          alt={category.name}
                          style={{ width: 25, height: 25 }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        {limitChar(category?.name)}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        {(category?.hashtags).join(", ")}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        {category.type === "post" ? "Post" : "Live"}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "14px",
                            lg: "15px",
                            xl: "15px",
                          },
                          color: "#333",
                          padding: {
                            xs: "10px 5px",
                            sm: "10px",
                            md: "10px",
                            lg: "10px 15px",
                            xl: "10px 15px",
                          },
                        }}
                      >
                        <IconButton
                          sx={{
                            "&:hover": {
                              backgroundColor: "#142C5C",
                              color: "#ffffff",
                            },
                          }}
                          onClick={(event) => handleClick(event, index)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={
                            Boolean(anchorEl) && selectedCategoryIndex === index
                          }
                          onClose={handleClose}
                          sx={{
                            "& .MuiPaper-elevation": {
                              borderRadius: "4px",
                              "& .MuiList-padding": {
                                padding: 0,
                              },
                            },
                          }}
                        >
                          <MenuItem
                            sx={{
                              padding: "5px 20px !important",
                              borderBottom: "1px solid #e0e0e0",
                              "&:hover": {
                                backgroundColor: "#e0e0e0 !important",
                                color: "#000",
                              },
                            }}
                            onClick={() => {
                              handleClose();
                              handleEditCategory(selectedCategoryIndex);
                            }}
                          >
                            Edit
                          </MenuItem>
                          {isAdmin && (
                            <MenuItem
                              sx={{
                                padding: "5px 20px !important",
                                borderBottom: "1px solid #e0e0e0",
                                "&:hover": {
                                  backgroundColor: "#e0e0e0 !important",
                                  color: "#000",
                                },
                              }}
                              onClick={() => {
                                handleClose();
                                handleOpenDeleteDialog(selectedCategoryIndex);
                              }}
                            >
                              Delete
                            </MenuItem>
                          )}
                          <MenuItem
                            sx={{
                              padding: "5px 20px !important",
                              "&:hover": {
                                backgroundColor: "#e0e0e0 !important",
                                color: "#000",
                              },
                            }}
                            onClick={() => {
                              handleClose();
                              handleViewCategory(selectedCategoryIndex);
                            }}
                          >
                            View
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <CommonPagination
            rowsPerPage={rowsPerPage}
            count={totalCategories}
            page={page}
            onPageChange={handlePageChange}
          />
        </Box>
      </Box>
);

export default CategoryTable;
